import React from 'react'
import { Box, Link, Typography } from '@material-ui/core'
import Lottie from 'react-lottie'
import animationData from '../../../assets/lottie/success-light.json'
import { InformationIcon, RestartIcon } from '../../SVGIcons'
import { useStyles } from '../Calculator.style'

const CalculatorSubmit = (data) => {
  const styles = useStyles()
  const { t } = data

  return (
    <Box className={styles.submitSuccessContainer}>
      <Box>
        <Link
          className={styles.resetCalculation}
          onClick={() => data.handleState('form')}
        >
          <Typography>{t('Calculate another lease')}</Typography>
          <RestartIcon />
        </Link>
      </Box>
      <Box className={styles.submitSuccessIconContainer}>
        <Lottie
          className={styles.submitSuccessLottieContainer}
          options={{
            autoplay: true,
            loop: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
        />
      </Box>
      <Typography variant="h4" className={styles.submitSuccessTitle}>
        {t('Request Submitted')}
      </Typography>
      <Typography variant="body1" className={styles.submitSuccessDescription}>
        <span>
          {t('Your leasing request')} <b>{t('Your leasing request - bold')}</b>
        </span>
      </Typography>
      <Box className={styles.informationContainer}>
        <Box className={styles.informationIconContainer}>
          <InformationIcon />
        </Box>
        <Box>
          <Typography variant="body1" className={styles.informationTitle}>
            {t('In the meantime')}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default CalculatorSubmit
